export const WARNING_POPUP_IMAGE_URL =
  'https://static.rfstat.com/renderforest/images/v2/video-editor-v2/warning.png'
